import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableRow from "@material-ui/core/TableRow";
import AutorenewIcon from "@material-ui/icons/Autorenew";
// import BatchStatus from '../models/BatchStatus';
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";

import { useStyles } from "../../supplierPoGrn/styles";
//Import custom table cell
import CustomTableCell from "../../models/table/CustomTableCell";
import {
  presentFormatedData,
  presentDate,
} from "../../functionalComponents/dataFormatFunctions";
import ViewBatchesScreen from "../common/drawer";
import ViewConsumptionInfo from "./ConsumptionDetails/index";
import StatusManager from "./StatusManager";
import StatusTextDispaly from "../../models/status/DeliveryCompleted";
import getColor from "../models/status/statusColors";
import { useHistory } from "react-router";
import EventNoteIcon from "@material-ui/icons/EventNote";
import VarianceMismatchButton from "./VarianceMismatchButton";
import GetAppIcon from "@material-ui/icons/GetApp";
import RefreshIcon from "@material-ui/icons/Refresh";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";
import {
  Dialog,
  Button,
  Typography,
  makeStyles,
  Box,
  CircularProgress,
  DialogContent,
  Grid,
} from "@material-ui/core";
import CustomDialogTitle from "../../projectsDashboard/CustomDialogTitle";
import ViewRmPMLots from "../batch/ViewRMPMLots/index";
import ViewStructuredInformation from "../batch/ViewStructuredInformation";
import ConsumptionDetailsCards from "../batch/ViewRMPMLots/ConsumptionDetailsCards";
// import ShowFiles from '../../models/files/ShowFiles';
import { downloadCustomUploadedFile } from '../../../../containers/actions/common/fileActions';
import getQAStatusColor from '../models/status/qaStatusColors';
import DownloadFilesDialogBox from './DownloadFilesDialogBox';
import GenerateGRNDialog from './GenerateGRNDialog';
import CreateIBDDialog from './CreateIBDDialog';

import useStyless from "../../models/buttons/buttonStyles";

function SingleRow(props) {
  const classes = useStyles();
  const classess = useStyless();
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    // schrockenSLBatchID,
    batchSize,
    batchStartDate,
    batchEndDate,
    manufacturingDate,
    grnGeneratedDate,
    batchUOM,
    fgMaterialCode,
    fgMaterialName,
    // scheduleLineItemNumber,
    // producedQuantity,
    // pendingQuantity,
    readyForDispatchQuantity,
    BOGeneratedGRNNumber,
    IBDNumber,
    // statusDescription,
    // statusID,
    statusDisplayName,
    SASLBatchStatusID,
    vendorBatchNumber,
    schrockenDeliveryScheduleBatchID,
    bomConsumptionAddedIndicator,
    rejectionText,
    rejectedBy,
    scheduleAgreementNumber,
    Yield,
    batchFulfilment,
    coaFiles,
    eInvoiceFiles,
    eWayBillFiles,
    customFiles,
    qaStatusID,
    qaStatusText,
    qaReasonForChangeInReleaseDecision,
    qaReleaseDecisionBy,
    qaRejectionReason,
    qaStatusUpdatedBy,
    vendorMosymphonyID,
    brandOwnerMosymphonyID,
    sendReminderForCOAUpload,
    scheduleLineItemNumber,
    targetQuantity,
    batchQty,
    bmrFiles,
    reviewPostMFGFieldsReqd,
    reviewPostShipmentFieldsReqd,
    reviewPreShipmentFieldsReqd,
    showGenerateGRNActionButton,
    showCreateIBDActionButton,
    vendorName,
    schrockenSLID,
    dateOfReceipt,
    reviewConsumptionReqd,
    reviewVarianceReqd,
    producedQtyVariancePresent,
    statDateVariancePresent,
    consumptionSameAsAllocation,
  } = props.row;
  const {
    schrockenDeliveryScheduleID,
    batchDashboard,
    featuresAccess: propsFeaturesAccess,
    cmoBatchNumber,
  } = props;  
//console.log("SASLBatchStatusID is here",SASLBatchStatusID)
  //console.log("here is the featuresAccess",propsFeaturesAccess);

  const [downloadBox, setDownloadBox] = useState(false);
  const [openConsumptionDialog, setOpenConsumptionDialog] = useState(false);
  const [openDigitizedDialog, setOpenDigitizedDialog] = useState(false);
  const [batchDetailsData, setBatchDetailsData] = useState(null);
  const [loadingBatchDetails, setLoadingBatchDetails] = useState(false);
  const [loadingCreateIBD, setLoadingCreateIBD] = useState(false);
  const [ibdDialog, setIbdDialog] = useState({ open: false, success: false, message: '', errorType: null, errorMessage: null });
  const [createIBDDialog, setCreateIBDDialog] = useState(false);
  const [generateGRNDialog, setGenerateGRNDialog] = useState(false);
  const [loadingGenerateGRN, setLoadingGenerateGRN] = useState(false);
  const [grnDialog, setGrnDialog] = useState({
    open: false,
    success: false,
    message: "",
    errorDetails: null,
  });

  const featuresAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.featuresAccess.deliverySchedulesFeatures
  );

  const dsData = useSelector((state) => state.pcmp.common.sasl.deliveryHeader);

  let poQuantity = batchDashboard
    ? targetQuantity
    : dsData?.data?.scheduledQuantity;

  const qualityApprovalFlowFlag = useSelector((state) => {
    return state.pcmp.common.reports.rmpmGrnFeatures?.data?.features
      ?.qualityApprovalEnabled;
  });

  const openScheduleLineDetails = () => {
    history.push(
      `/pcmp/${localStorage.collabType}/${localStorage.roleName}/${localStorage.organizationName}/${localStorage.ecosystemId}/sasl/${schrockenDeliveryScheduleID}`,
      { batchDashboard: batchDashboard }
    );
  };

  const openDownloadDialogBox = () => {
    setDownloadBox(true);
  };

  const handleDownloadDialog = () => {
    setDownloadBox(false);
  };

  const handleGenerateGRNDialog = () => {
    setGenerateGRNDialog(!generateGRNDialog);
  };

  const handleGenerateGRNDialogClose = () => {
    setGenerateGRNDialog(false);

    if (props.onRefreshData) {
      props.onRefreshData();
    }
  };

  const handleDownloadFile = (schrockenCustomFileID) => {
    const data = {
      schrockenCustomFileID,
    };
    dispatch(downloadCustomUploadedFile(data));
  };

  // API call to fetch batch details and get collabrixProductID
  const fetchBatchDetails = async () => {
    if (!schrockenDeliveryScheduleBatchID) {
      console.error("schrockenDeliveryScheduleBatchID is required");
      return;
    }

    setLoadingBatchDetails(true);
    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDeliveryScheduleBatchDetails`;
      const payload = {
        schrockenDeliveryScheduleBatchID: schrockenDeliveryScheduleBatchID,
        poNumber: scheduleAgreementNumber,
        batchNumber: vendorBatchNumber,
        //cmoBatchNumber: cmoBatchNumber,
      };

      const response = await axios.post(url, payload);

      if (response.data.status) {
        //console.log('Batch details API response:', response.data.data);
        setBatchDetailsData(response.data.data);

        // Update poQuantity if we have targetQuantity from batch data
        if (response.data.data.targetQuantity) {
          poQuantity = response.data.data.targetQuantity;
          //console.log('Updated poQuantity from batch data:', poQuantity);
        }

        return response.data.data;
      } else {
        console.error("API returned error status:", response.data);
        return null;
      }
    } catch (error) {
      console.error("Error fetching batch details:", error);
      return null;
    } finally {
      setLoadingBatchDetails(false);
    }
  };

  // Open Create IBD Dialog
  const handleCreateIBD = () => {
    setCreateIBDDialog(true);
  };

  // Handle Create IBD Dialog Close
  const handleCreateIBDDialogClose = () => {
    setCreateIBDDialog(false);
  };
  // Handle IBD Creation Success/Error from Dialog
  const handleIBDCreationResult = (result) => {
    if (result.success) {
      setIbdDialog({
        open: true,
        success: true,
        message: result.message || 'IBD created successfully!',
        errorType: null,
        errorMessage: null
      });
      // Do NOT refresh here: getBatches() dispatches loadTableData() which sets
      // tableLoading=true and unmounts the table rows — that would unmount this
      // row (and the success dialog it owns) the instant it opens, so the popup
      // never appears. The dashboard is refreshed on dialog close
      // (handleIbdDialogClose), matching the working GRN flow — so the IBD number
      // updates without a manual page refresh once the popup is dismissed.
    } else {
      setIbdDialog({
        open: true,
        success: false,
        message: result.message || 'IBD generation failed',
        errorType: result.errorType || '',
        errorMessage: result.errorMessage || 'Unknown error occurred'
      });
    }
  };

  const handleIbdDialogClose = () => {
    //console("Closing IBD dialog, current state:", ibdDialog);

    setIbdDialog((prev) => ({ ...prev, open: false }));

    // Reset dialog state after a short delay to avoid flickering
    setTimeout(() => {
      setIbdDialog({
        open: false,
        success: false,
        message: "",
        errorType: null,
        errorMessage: null,
      });

      //console("Calling onRefreshData after dialog close");
      if (props.onRefreshData) {
        props.onRefreshData();
      }
    }, 100);
  };
  //   const handleGenerateGRNforpopupcase = async () => {

  //     setGenerateGRNDialog(true);

  // };
  // Handle GRN generation - direct API call like IBD
  const handleGenerateGRN = async () => {
    if (!schrockenDeliveryScheduleBatchID) {
      console.error("schrockenDeliveryScheduleBatchID is required");
      setGrnDialog({
        open: true,
        success: false,
        message: "GRN generation failed - Missing batch ID",
        errorDetails: null,
      });
      return;
    }

    setGrnDialog({
      open: true,
      success: false,
      message: "",
      errorDetails: null,
    });
    setLoadingGenerateGRN(true);

    try {
      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/generateGRNFromFE`;
      const payload = {
        schrockenDeliveryScheduleBatchID: schrockenDeliveryScheduleBatchID,
        poNumber: scheduleAgreementNumber,
        batchNumber: vendorBatchNumber,
      };

      const response = await axios.post(url, payload);

      if (response.data.success) {
        setGrnDialog({
          open: true,
          success: true,
          message: "GRN generated successfully",
        });
      } else {
        console.error("GRN generation failed:", response.data);
        setGrnDialog({
          open: true,
          success: false,
          message: "GRN generation failed",
          errorDetails: response.data.details.errors.errorGRN,
        });
      }
    } catch (error) {
      //console("Error generating GRN:", error);
      if (error.response) {
        if (error.response.status === 500) {
          setGrnDialog({
            open: true,
            success: false,
            message: "GRN generation failed - Server error (500)",
            errorDetails:
              error.response?.data?.details?.errors?.errorGRN ||
              error.response?.data?.message ||
              error.response?.data?.error ||
              "Unknown error occurred",
          });
        } else {
          setGrnDialog({
            open: true,
            success: false,
            message: `GRN generation failed - Server responded with status ${error.response.status}`,
            errorDetails:
              error.response?.data?.serverError ||
              error.response?.data?.details?.errors?.errorGRN ||
              error.response?.data?.message ||
              error.response?.data?.error ||
              "Unknown error occurred",
          });
        }
      } else if (error.request) {
        setGrnDialog({
          open: true,
          success: false,
          message: "GRN generation failed - No response from server",
          errorDetails:
            "Please check your network connection or try again later.",
        });
      } else {
        setGrnDialog({
          open: true,
          success: false,
          message: "GRN generation failed - Unexpected error",
          errorDetails: error.message || "Unknown error occurred",
        });
      }
    } finally {
      setLoadingGenerateGRN(false);
    }
  };

  const handleGrnDialogClose = () => {
    //console("Closing GRN dialog, current state:", grnDialog);

    setGrnDialog((prev) => ({ ...prev, open: false }));

    setTimeout(() => {
      setGrnDialog({
        open: false,
        success: false,
        message: "",
        errorDetails: null,
      });

      //console("Calling onRefreshData after GRN dialog close");
      if (props.onRefreshData) {
        props.onRefreshData();
      }
    }, 100);
  };

  const handleConsumptionDialogClose = async () => {
    setOpenConsumptionDialog(false);
    await fetchBatchDetails();
    if (props.onRefreshData) {
      props.onRefreshData();
    }
  };

  const handleDigitizedDialogClose = async () => {
    setOpenDigitizedDialog(false);
    await fetchBatchDetails();
    if (props.onRefreshData) {
      props.onRefreshData();
    }
  };

  // Single navigation function that handles all review types
  const handleReviewNavigation = async () => {
    // Fetch batch details to get collabrixProductID and other data
    const batchData = await fetchBatchDetails();

    if (!batchData) {
      console.error("Failed to fetch batch details");
      return;
    }

    // Condition 1: If reviewPostMFGFieldsReqd is true, open View Consumption dialog
    if (reviewPostMFGFieldsReqd) {
      setOpenConsumptionDialog(true);
    }
    // Condition 2: If reviewPostMFGFieldsReqd is false but reviewPostShipmentFieldsReqd OR reviewPreShipmentFieldsReqd is true, open View Digitized Information dialog
    else if (reviewPostShipmentFieldsReqd || reviewPreShipmentFieldsReqd) {
      setOpenDigitizedDialog(true);
    }
    // Condition 3: If none of the review fields are true, open View Digitized Information dialog as default
    else {
      setOpenDigitizedDialog(true);
    }
  };

  const handleRefresh = () => {
    props.onRefreshData();
  };

  return (
    <React.Fragment>
      <TableRow
        className={classes.root}
        style={{
          backgroundColor: props.keys % 2 === 0 ? "#FFF" : "#0000000a",
        }}
        // key={GRDetails[0].schrockenSupplierPOBatchID}
      >
        {/* <TableCell
          style={{
            width: '1%',
            maxWidth: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          <IconButton aria-label='expand row' size='small' />
        </TableCell> */}

        <CustomTableCell align="left">
          {presentFormatedData(vendorBatchNumber)}
        </CustomTableCell>

        <CustomTableCell align="left">
          {presentFormatedData(fgMaterialCode)}
          {"/"}
          <br />
          {presentFormatedData(fgMaterialName)}
        </CustomTableCell>

        {batchDashboard && (
          <CustomTableCell align="center">
            {presentFormatedData(scheduleAgreementNumber)} -{" "}
            {presentFormatedData(scheduleLineItemNumber)}
          </CustomTableCell>
        )}
        {batchDashboard && (
          <CustomTableCell align="center">
            {presentDate(dateOfReceipt)}
          </CustomTableCell>
        )}
        {batchDashboard && (
          <CustomTableCell align="right">
            {presentFormatedData(batchUOM)}
          </CustomTableCell>
        )}

        <CustomTableCell align="right">
          {presentFormatedData(
            batchQty !== null && batchQty !== undefined && Number.isFinite(Number(batchQty))
              ? parseFloat(Number(batchQty).toFixed(3))
              : batchQty
          )}
        </CustomTableCell>
        {/* <CustomTableCell align='right'>
          {presentFormatedData(producedQuantity)}
        </CustomTableCell>
        <CustomTableCell align='right'>
          {presentFormatedData(pendingQuantity)}
        </CustomTableCell> */}
        <CustomTableCell
          align={"right"}
        >
          {presentFormatedData(
            readyForDispatchQuantity !== null && readyForDispatchQuantity !== undefined && Number.isFinite(Number(readyForDispatchQuantity))
              ? parseFloat(Number(readyForDispatchQuantity).toFixed(3))
              : readyForDispatchQuantity
          )}
        </CustomTableCell>

        {batchDashboard && (
          <CustomTableCell
            align={"right"}
          >
            {batchFulfilment !== null && batchFulfilment !== undefined && batchFulfilment !== '' 
              ? (() => {
                  const numValue = typeof batchFulfilment === 'number' ? batchFulfilment : parseFloat(batchFulfilment);
                  return Number.isInteger(numValue) ? numValue.toString() : numValue.toFixed(3);
                })()
              : presentFormatedData(batchFulfilment)}
          </CustomTableCell>
        )}
        <CustomTableCell align="center">
          {presentDate(manufacturingDate)}
        </CustomTableCell>
        <CustomTableCell align="center">
          {grnGeneratedDate && grnGeneratedDate !== '-NA-' && grnGeneratedDate.includes(',') ? (
            grnGeneratedDate.split(',').map((date, index, array) => (
              <React.Fragment key={index}>
                {presentDate(date.trim())}
                {index < array.length - 1 && <>,<br /></>}
              </React.Fragment>
            ))
          ) : (
            presentDate(grnGeneratedDate)
          )}
        </CustomTableCell>
        <CustomTableCell align='center'>
          {(BOGeneratedGRNNumber && BOGeneratedGRNNumber !== '-NA-') || (IBDNumber && IBDNumber !== '-NA-') ? (
            (BOGeneratedGRNNumber && BOGeneratedGRNNumber !== '-NA-' ? BOGeneratedGRNNumber : IBDNumber).split(',').map((grn, index, array) => (
              <React.Fragment key={index}>
                {grn.trim()}
                {index < array.length - 1 && <>,<br /></>}
              </React.Fragment>
            ))
          ) : (
            presentFormatedData(BOGeneratedGRNNumber || IBDNumber)
          )}
        </CustomTableCell>

        <CustomTableCell>
          <StatusTextDispaly
            statusText={statusDisplayName}
            bgColor={getColor(SASLBatchStatusID)}
          />
        </CustomTableCell>
        {/* 
           Example buttons with conditions using both row data and featuresAccess
         */}

        {qualityApprovalFlowFlag && (
          <CustomTableCell>
            <StatusTextDispaly
              statusText={qaStatusText ? qaStatusText : "-NA-"}
              bgColor={getQAStatusColor(qaStatusID)}
            />
          </CustomTableCell>
        )}
        <CustomTableCell className={classes.changingWidth} align="left">
          <div className={classes.actions}>
            <div>
              {StatusManager(
                schrockenDeliveryScheduleID,
                schrockenDeliveryScheduleBatchID,
                SASLBatchStatusID,
                statusDisplayName,
                rejectionText,
                rejectedBy,
                featuresAccess,
                batchDashboard,
                qualityApprovalFlowFlag,
                qaStatusID,
                qaStatusText,
                qaReasonForChangeInReleaseDecision,
                qaReleaseDecisionBy,
                qaRejectionReason,
                qaStatusUpdatedBy,
                vendorMosymphonyID,
                brandOwnerMosymphonyID,
                sendReminderForCOAUpload,
                scheduleLineItemNumber,
                scheduleAgreementNumber,
                vendorBatchNumber,
                fgMaterialCode,
                fgMaterialName,
                poQuantity,
                props.isBatchDashboard,
                props.row,
                schrockenSLID,
                vendorName,
                batchUOM,
                batchSize,
                bomConsumptionAddedIndicator,
                handleRefresh,
                reviewConsumptionReqd
              )}
            </div>
            {/* <AssignmentIcon
                titleAccess='Generate GRN'
                fontSize='small'
                className={classes.multipleLogo}
                onClick={handleGenerateGRNDialog}
              /> */}
            {/* <Button
                disableElevation
                disableFocusRipple
                disableRipple
                // className={classes.button}
                onClick={handleGenerateGRNDialog}
              >
                <div className={classes.logo}>
                  <AutorenewIcon fontSize='small' className={classes.logoHeight} />
                  &nbsp;
                  <Typography variant='body1'>Generate GRN</Typography>
                </div>
              </Button> */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                {propsFeaturesAccess?.reviewFields &&
                  (reviewPostMFGFieldsReqd ||
                    reviewPostShipmentFieldsReqd ||
                    reviewPreShipmentFieldsReqd) &&
                  (SASLBatchStatusID === 5 ||
                    SASLBatchStatusID === 45 ||
                    SASLBatchStatusID === 50) && (
                    <Button
                      variant="outlined"
                      color="white"
                      //  /display="inline-block"
                      style={{ textTransform: "none" }}
                      className={classess.button}
                      onClick={handleReviewNavigation}
                      size="small"
                      disabled={loadingBatchDetails}
                      startIcon={
                        loadingBatchDetails ? (
                          <CircularProgress size={16} color="inherit" />
                        ) : (
                          <div
                            style={{
                              width: 14,
                              height: 19,
                              borderRadius: "50%",
                              backgroundColor: "white",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "grey",
                            }}
                          >
                            <AutorenewIcon
                              fontSize="small"
                              className={classes.logoHeight}
                            />
                          </div>
                        )
                      }
                    >
                      {loadingBatchDetails ? "Loading..." : "Review Fields"}
                    </Button>
                  )}
                {propsFeaturesAccess?.generateGRN &&
                  showGenerateGRNActionButton && (
                    <Button
                      variant="outlined"
                      color="white"
                      style={{ textTransform: "none" }}
                      className={classess.button}
                      // onClick={handleGenerateGRN}
                      onClick={handleGenerateGRNDialog}
                      //onClick={handleGenerateGRNforpopupcase}
                      disabled={loadingGenerateGRN}
                      startIcon={
                        <div
                          style={{
                            width: 14,
                            height: 19,
                            borderRadius: "50%",
                            backgroundColor: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "grey",
                          }}
                        >
                          <AutorenewIcon
                            fontSize="small"
                            className={classes.logoHeight}
                          />
                        </div>
                      }
                    >
                      {loadingGenerateGRN ? "Generating..." : "Generate GRN"}
                    </Button>
                  )}
                {propsFeaturesAccess?.createIBD &&
                  showCreateIBDActionButton && (
                    <Button
                      variant="outlined"
                      color="white"
                      style={{ textTransform: "none" }}
                      // style={{marginBottom: '5px'}}
                      className={classess.button}
                      onClick={handleCreateIBD}
                      disabled={loadingCreateIBD}
                      startIcon={
                        <div
                          style={{
                            width: 14,
                            height: 19,
                            borderRadius: "50%",
                            backgroundColor: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "grey",
                          }}
                        >
                          <AutorenewIcon
                            fontSize="small"
                            className={classes.logoHeight}
                          />
                        </div>
                      }
                    >
                      {loadingCreateIBD ? "Creating..." : "Create IBD"}
                    </Button>
                  )}
                {featuresAccess?.approveFGConsumption && (reviewVarianceReqd === true || SASLBatchStatusID === 40) && localStorage.getItem('collabType') !== 'CMO' && (
                  <VarianceMismatchButton
                    row={props.row}
                    onRefreshData={props.onRefreshData}
                  />
                )}
              </div>
              {featuresAccess?.viewFGBatch && (
                <ViewBatchesScreen
                  className={classes.multipleLogo}
                  schrockenDeliveryScheduleBatchID={
                    schrockenDeliveryScheduleBatchID
                  }
                  schrockenDeliveryScheduleID={schrockenDeliveryScheduleID}
                  qualityApprovalFlowFlag={qualityApprovalFlowFlag}
                  poQuantity={poQuantity}
                  batchRowData={props.row}
                />
              )}
              {featuresAccess?.viewFGConsumption &&
                bomConsumptionAddedIndicator && (
                  <ViewConsumptionInfo
                    className={classes.multipleLogo}
                    schrockenDeliveryScheduleBatchID={
                      schrockenDeliveryScheduleBatchID
                    }
                    schrockenDeliveryScheduleID={schrockenDeliveryScheduleID}
                    bomConsumptionAddedIndicator={bomConsumptionAddedIndicator}
                    targetQuantity={poQuantity}
                    files={bmrFiles}
                    batchRowData={props.row}
                  />
                )}
              {/* {batchDashboard && (
                <>
                  
                  <EventNoteIcon
                  fontSize='small'
                  className={classes.multipleLogo}
                  onClick={openScheduleLineDetails}
                />
                </>
              )} */}
              {qualityApprovalFlowFlag && (
                <GetAppIcon
                  titleAccess="Download CoA"
                  fontSize="small"
                  className={
                    coaFiles.length !== 0 ||
                    eInvoiceFiles.length !== 0 ||
                    eWayBillFiles.length !== 0 ||
                    customFiles.length !== 0
                      ? classes.multipleLogo
                      : classes.multipleLogoDisable
                  } // Spira Id: 2572 (Enable download when files are present.)
                  onClick={
                    coaFiles.length !== 0 ||
                    eInvoiceFiles.length !== 0 ||
                    eWayBillFiles.length !== 0 ||
                    customFiles.length !== 0
                      ? openDownloadDialogBox
                      : null
                  } // Spira Id: 2572 (one dialog box to download files when files are present.)
                />
              )}
            </div>
          </div>
        </CustomTableCell>
      </TableRow>
      <Dialog
        open={downloadBox}
        onClose={handleDownloadDialog}
        fullWidth
        maxWidth={"md"}
      >
        <DownloadFilesDialogBox
          handleDownloadDialog={handleDownloadDialog}
          handleDownloadFile={handleDownloadFile}
          coaFiles={coaFiles}
          eInvoiceFiles={eInvoiceFiles}
          eWayBillFiles={eWayBillFiles}
          customFiles={customFiles}
          qualityApprovalFlowFlag={qualityApprovalFlowFlag}
        />
        {/* <DialogContent>
          <Grid container justifyContent='flex-end'>
            <Grid item sm={6}>
              <Typography
                style={{
                  textAlign: 'center',
                  fontSize: '1.25rem',
                  fontWeight: 500,
                }}
              >
                Download CoA File(s)
              </Typography>
            </Grid>
            <Grid item sm={3}>
              <Typography
                className={classes.closeText}
                variant='body2'
                onClick={handleDownloadDialog}
              >
                Close <CloseIcon fontSize='medium' />
              </Typography>
            </Grid>
          </Grid>
          {coaFiles.length > 0 && (
            <React.Fragment>
              <Grid
                container
                style={{ justifyContent: 'center', padding: '2rem' }}
              >
                {coaFiles.length > 0
                  ? coaFiles.map((file, index) => (
                      <Grid
                        item
                        xs={12}
                        key={index}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <Typography
                          variant={'body2'}
                          // className={classes.link}
                          style={{
                            color: 'blue',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                            padding: '5px 0px',
                          }}
                          onClick={() =>
                            handleDownloadFile(file.schrockenCustomFileID)
                          }
                        >
                          {file.fileName || file.name || file.customFileName}
                        </Typography>
                      </Grid>
                    ))
                  : null}
              </Grid>
            </React.Fragment>
          )}
        </DialogContent> */}
      </Dialog>
      
      <CreateIBDDialog
        key={schrockenDeliveryScheduleBatchID}
        open={createIBDDialog}
        onClose={handleCreateIBDDialogClose}
        batchData={{
          ...props.row,
          vendorMosymphonyID: vendorMosymphonyID,
          schrockenDeliveryScheduleBatchID: schrockenDeliveryScheduleBatchID,
          poNumber: scheduleAgreementNumber,
          batchNumber: vendorBatchNumber,
          statusDisplayName: statusDisplayName,
          SASLBatchStatusID: SASLBatchStatusID,
          qtyAlreadyDispatched: props.row.qtyAlreadyDispatched,
          lastShippedDate: props.row.lastShippedDate,
          remainingQtyTobeShipped: props.row.remainingQtyTobeShipped || props.row.remainingQtyToBeShipped,
        }}
        onSuccess={handleIBDCreationResult}
      />
      
      <GenerateGRNDialog
        key={schrockenDeliveryScheduleBatchID}
        open={generateGRNDialog}
        onClose={handleGenerateGRNDialogClose}
        batchData={{
          ...props.row,
          vendorMosymphonyID: vendorMosymphonyID,
          schrockenDeliveryScheduleBatchID: schrockenDeliveryScheduleBatchID,
          poNumber: scheduleAgreementNumber,
          batchNumber: vendorBatchNumber,
          SASLBatchStatusID: SASLBatchStatusID,
          statusDisplayName: statusDisplayName,
          qtyAlreadyDispatched: props.row.qtyAlreadyDispatched,
          lastShippedDate: props.row.lastShippedDate,
          remainingQtyTobeShipped: props.row.remainingQtyTobeShipped || props.row.remainingQtyToBeShipped,
          readyForDispatchQuantity: readyForDispatchQuantity,
        }}
      />

      {/* View Consumption Dialog */}
      <Dialog open={openConsumptionDialog} fullScreen>
        <CustomDialogTitle
          onBackClick={handleConsumptionDialogClose}
          title={"View Consumption"}
        />
        <ViewRmPMLots
          batchDetails={
            batchDetailsData
              ? {
                  ...batchDetailsData,
                  digitizedData: batchDetailsData.digitizedExtractedData || [],
                  existingCustomFiles: batchDetailsData.customFilesList || [],
                  collabrixProductID: batchDetailsData.collabrixProductID,
                }
              : {
                  ...props.row,
                  digitizedData: props.row.digitizedExtractedData || [],
                  existingCustomFiles: props.row.customFilesList || [],
                  collabrixProductID: props.row.collabrixProductID,
                }
          }
          selectedDeliveryBatchID={schrockenDeliveryScheduleBatchID}
          targetQuantity={poQuantity}
          row={{
            batchDetails: batchDetailsData
              ? {
                  ...batchDetailsData,
                  digitizedData: batchDetailsData.digitizedExtractedData || [],
                  existingCustomFiles: batchDetailsData.customFilesList || [],
                  collabrixProductID: batchDetailsData.collabrixProductID,
                }
              : {
                  ...props.row,
                  digitizedData: props.row.digitizedExtractedData || [],
                  existingCustomFiles: props.row.customFilesList || [],
                  collabrixProductID: props.row.collabrixProductID,
                },
            scheduleLineDetails: {
              schrockenSLID: props.row.schrockenSLID,
              targetQuantity: poQuantity,
              vendorMosymphonyID: props.row.vendorMosymphonyID,
            },
          }}
          dashboardViewConsumption={false}
          poDashboardBatch={false}
          featureAccess={propsFeaturesAccess}
          schrockenDeliveryScheduleID={schrockenDeliveryScheduleID}
          showRMPMDetails={true}
          cmoBatchNumber={cmoBatchNumber}
        />
      </Dialog>

      {/* View Digitized Information Dialog */}
      <Dialog open={openDigitizedDialog} fullScreen>
        <CustomDialogTitle
          onBackClick={handleDigitizedDialogClose}
          title={"View Digitalized Information"}
        />
        <ViewStructuredInformation
          batchDetails={
            batchDetailsData
              ? {
                  ...batchDetailsData,
                  digitizedExtractedData:
                    batchDetailsData.digitizedExtractedData || [],
                  customFilesList: batchDetailsData.customFilesList || [],
                  collabrixProductID: batchDetailsData.collabrixProductID,
                }
              : props.row
          }
          schrockenDeliveryScheduleID={schrockenDeliveryScheduleID}
          targetQuantity={poQuantity}
          cmoBatchNumber={cmoBatchNumber}
        />
      </Dialog>

      {/* IBD Success/Error Dialog */}
      <Dialog
        open={ibdDialog.open}
        onClose={loadingCreateIBD ? undefined : handleIbdDialogClose}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          {loadingCreateIBD ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="300px"
            >
              <CircularProgress
                color="primary"
                size={60}
                style={{ marginBottom: "1rem" }}
              />
            </Box>
          ) : (
            <>
              <Grid container justifyContent="flex-end">
                <Typography
                  variant="body2"
                  style={{
                    fontSize: "1rem",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={handleIbdDialogClose}
                >
                  Close <CloseIcon fontSize="large" />
                </Typography>
                <Grid
                  item
                  xs={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  {ibdDialog.success ? (
                    <CheckCircleIcon
                      style={{
                        fontSize: "5rem",
                        color: "#008002",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "5rem",
                        height: "5rem",
                        borderRadius: "50%",
                        backgroundColor: "#F00",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                      }}
                    >
                      <CloseIcon
                        style={{
                          fontSize: "3rem",
                          color: "white",
                        }}
                      />
                    </div>
                  )}
                </Grid>
              </Grid>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "80px",
                  padding: "1rem",
                }}
              >
                <Typography
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                    marginBottom: "0.5rem",
                  }}
                >
                  {ibdDialog.message}
                </Typography>
                {!ibdDialog.success && (
                  <>
                    <Typography
                      style={{
                        textAlign: "left",
                        fontSize: "1rem",
                        marginTop: "0.5rem",
                        color: "#666",
                        width: "100%",
                      }}
                    >
                      There was some error in IBD Details submission. Please try again later.
                    </Typography>
                    <ul style={{ textAlign: "left", marginTop: "12px", paddingLeft: "20px", listStyleType: "disc", width: "100%" }}>
                      {/* {ibdDialog.errorType && (
                        <li style={{ marginBottom: "8px" }}>
                          <Typography component="span" style={{ fontSize: "1rem", color: "#333" }}>
                            Error type as received - {ibdDialog.errorType}
                          </Typography>
                        </li>
                      )} */}
                      {ibdDialog.errorMessage && (
                        <li style={{ marginBottom: "8px" }}>
                          <Typography component="span" style={{ fontSize: "1rem", color: "#333" }}>
                            Error message as received - {ibdDialog.errorMessage}
                          </Typography>
                        </li>
                      )}
                    </ul>
                    <Typography
                      style={{
                        textAlign: "left",
                        fontSize: "1rem",
                        marginTop: "1rem",
                        color: "#666",
                        width: "100%",
                      }}
                    >
                      Jira link for issue - <a href="https://collabrix-jsm.atlassian.net/servicedesk/customer/portal/1/group/34/create/67" target="_blank" rel="noopener noreferrer">https://collabrix-jsm.atlassian.net/servicedesk/customer/portal/1/group/34/create/67</a>
                    </Typography>
                  </>
                )}
              </div>
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  padding: "0.5rem",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRightIcon />}
                  onClick={handleIbdDialogClose}
                  style={{
                    paddingLeft: "3rem",
                    paddingRight: "3rem",
                  }}
                >
                  OK
                </Button>
              </Grid>
            </>
          )}
        </DialogContent>
      </Dialog>

      {/* GRN Success/Error Dialog */}
      <Dialog
        open={grnDialog.open}
        onClose={loadingGenerateGRN ? undefined : handleGrnDialogClose}
        fullWidth
      >
        <DialogContent style={{ padding: "2rem" }}>
          {loadingGenerateGRN ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              minHeight="300px"
            >
              <CircularProgress
                color="primary"
                size={60}
                style={{ marginBottom: "1rem" }}
              />
            </Box>
          ) : (
            <>
              <Grid container justifyContent="flex-end">
                <Typography
                  variant="body2"
                  style={{
                    fontSize: "1rem",
                    fontWeight: 500,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={handleGrnDialogClose}
                >
                  Close <CloseIcon fontSize="large" />
                </Typography>
                <Grid
                  item
                  xs={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  {grnDialog.success ? (
                    <CheckCircleIcon
                      style={{
                        fontSize: "5rem",
                        color: "#008002",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "5rem",
                        height: "5rem",
                        borderRadius: "50%",
                        backgroundColor: "#F00",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                      }}
                    >
                      <CloseIcon
                        style={{
                          fontSize: "3rem",
                          color: "white",
                        }}
                      />
                    </div>
                  )}
                </Grid>
              </Grid>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "80px",
                  padding: "1rem",
                }}
              >
                <Typography
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "1.5rem",
                    marginBottom: "0.5rem",
                  }}
                >
                  {grnDialog.message}
                </Typography>
                {grnDialog.errorDetails && (
                  <Typography
                    style={{
                      textAlign: "center",
                      fontSize: "1rem",
                      color: "#d32f2f",
                      fontWeight: "normal",
                    }}
                  >
                    {grnDialog.errorDetails}
                  </Typography>
                )}
              </div>
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  padding: "0.5rem",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<ChevronRightIcon />}
                  onClick={handleGrnDialogClose}
                  style={{
                    paddingLeft: "3rem",
                    paddingRight: "3rem",
                  }}
                >
                  OK
                </Button>
              </Grid>
            </>
          )}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
export default SingleRow;
